import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";

/**
 * Проверяет, внешний домен у url или нет
 * @param url
 */
var isExternalHost = function isExternalHost(url) {
  if (typeof window !== "undefined") {
    try {
      var _window$location = window.location,
          hostname = _window$location.hostname,
          origin = _window$location.origin;
      var fullUrl = new URL(url, origin);
      return hostname !== fullUrl.hostname;
    } catch (error) {
      console.warn(error);
    }
  }

  return false;
};

export default isExternalHost;